
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { IGameItemForSaleByGala } from '~/store/games/types';
import {
  ISanityDocuments,
  SanityDocumentSchema,
} from '~/types/sanity-documents';
import { getIsCompletelySoldOut } from '~/utils/productSupply';
import VideoPlayerMinimal from '~/components/UIComponents/VideoPlayerMinimal.vue';

@Component({
  components: {
    VideoPlayerMinimal,
  },
})
export default class NftCardMedia extends Vue {
  @Prop(Object) readonly doc!: ISanityDocuments[SanityDocumentSchema.NFT_CARD];
  @Prop(Object) readonly item!: IGameItemForSaleByGala;
  @Prop({ type: Number, default: 400 }) readonly size!: number;

  get completelySoldOut() {
    return getIsCompletelySoldOut(this.item);
  }

  get imageUrl() {
    const image =
      this.doc?.image || this.item?.image || this.item?.images?.[0]?.url;

    if (!image) {
      return;
    }

    if (typeof image === 'string') {
      return image;
    }

    const imageSource = {
      asset: image.asset,
      crop: image.crop,
      hotspot: image.hotspot,
    };

    return this.$sanityImage
      .urlFor(imageSource)
      .height(this.size)
      .width(this.size)
      .url();
  }

  get videoUrl() {
    if (this.doc?.animationUrl) {
      return this.doc.animationUrl;
    }

    if (this.imageUrl?.endsWith('.mp4')) {
      return this.imageUrl;
    }
  }

  get title() {
    return this.doc?.title || this.item.name;
  }
}
